import {useMutation} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";

import {isBreakBusinessError} from "../lib/break-action-errors";
import {officerService} from "../services";

export function useBreakAction() {
  return useMutation({
    mutationFn: officerService.breakAction,
    onError: (error) => {
      if (isBreakBusinessError(error)) return;
      errorHandler(error);
    },
  });
}
